module.exports = __webpack_public_path__ + "static/media/move_front.54e5b540.png";